import { arrow, downLogo, blogLogo, mainLogo, spLogo, blackMainLogo, blackDownLogo, blackBlogLogo, blackSpLogo, blackArrow, headerMenuIcon, headerMenuIconGray, referenceLogo, blackReferenceLogo } from '../assets/images/header/headerImages';

export const updateHeaderColor = () => {
  const headerElements = document.querySelectorAll('#navMenu > li');
  const header = document.querySelector('.header');
  const headerLine = document.querySelector('#headerLine');
  const fixLine = document.querySelector('#headerLine');
  const headerTexts = document.querySelectorAll('.headerSmallText');
  const headerMainLogo = document.querySelector('#mainLogo');
  const headerDownLogo = document.querySelector('#downIcon');
  const headerReferenceLogo = document.querySelector('#referenceIcon');
  const headerBlogIcon = document.querySelector('#blogIcon');
  const headerSpIcon = document.querySelector('#spIcon');
  const headerIconLine = document.querySelector('#headerConLine');
  const headerArrows = document.querySelectorAll('.mainHeaderArrow');

  if (window.scrollY >= 126) {
    headerElements.forEach(element => {
      element.style.color = 'black';
    });
    headerArrows.forEach(element => {
      element.src = blackArrow;
      element.style.marginLeft = '5px';
    });
    headerLine.style.backgroundColor = 'rgba(0, 0, 0, 0.30)';
    fixLine.style.borderLeft = '1px solid rgba(0, 0, 0, 0.30)';
    header.style.backgroundColor = 'white';
    
    headerTexts.forEach(element => {
      element.style.color = 'black';
    });
    headerMainLogo.src = blackMainLogo;
    headerDownLogo.src = blackDownLogo;
    headerReferenceLogo.src = blackReferenceLogo;
    headerBlogIcon.src = blackBlogLogo;
    headerSpIcon.src = blackSpLogo;
    headerIconLine.style.backgroundColor = 'black';
  } else {
    headerElements.forEach(element => {
      element.style.color = 'white';
    });
    headerArrows.forEach(element => {
      element.src = arrow;
      element.style.marginLeft = '0px';
    });
    headerLine.style.backgroundColor = '#ffffff2e'
    fixLine.style.borderLeft = '1px solid rgba(255, 255, 255, 0.1)';
    header.style.backgroundColor = '';
    headerTexts.forEach(element => {
      element.style.color = 'white';
    });
    headerMainLogo.src = mainLogo;
    headerDownLogo.src = downLogo;
    headerReferenceLogo.src = referenceLogo;
    headerBlogIcon.src = blogLogo;
    headerSpIcon.src = spLogo;
    headerIconLine.style.backgroundColor = '#ffffff72';
  }
};


export const updateMobileHeaderColor = () => {
  const header = document.querySelector('.header');
  const headerMainLogo = document.querySelector('#mainLogo');
  const headerDownLogo = document.querySelector('#downIcon');
  const headerReferenceLogo = document.querySelector('#referenceIcon');
  const headerBlogIcon = document.querySelector('#blogIcon');
  const headerSpIcon = document.querySelector('#spIcon');
  const headerIconLine = document.querySelector('#headerConLine');
  const headerMenuBtn = document.querySelector('#heaer-menu-btn');
  
  if (window.scrollY >= 90) {
    header.style.backgroundColor = 'white';
    headerMainLogo.src = blackMainLogo;
    headerDownLogo.src = blackDownLogo;
    headerReferenceLogo.src = blackReferenceLogo;
    headerBlogIcon.src = blackBlogLogo;
    headerSpIcon.src = blackSpLogo;
    headerIconLine.style.backgroundColor = 'black';
    headerMenuBtn.src = headerMenuIconGray;
  } else {
    header.style.backgroundColor = '';
    headerMainLogo.src = mainLogo;
    headerDownLogo.src = downLogo;
    headerReferenceLogo.src = referenceLogo;
    headerBlogIcon.src = blogLogo;
    headerSpIcon.src = spLogo;
    headerIconLine.style.backgroundColor = '#ffffff72';
    headerMenuBtn.src = headerMenuIcon;
  }
};